module.exports = __webpack_public_path__ + "img/reju2.84f6faf9.png";